import { render } from "./clientes-pesquisa.vue?vue&type=template&id=a48c31ba"
import script from "./clientes-pesquisa.vue?vue&type=script&lang=js"
export * from "./clientes-pesquisa.vue?vue&type=script&lang=js"

import "./clientes-pesquisa.vue?vue&type=style&index=0&id=a48c31ba&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__